import { useMemo, useRef } from 'react';

const useInputFocus = () => {
    const htmlElRef = useRef<HTMLElement>(null);
    return useMemo(
        () =>
            [
                htmlElRef,
                () => {
                    htmlElRef.current?.focus();
                },
            ] as const,
        []
    );
};

export default useInputFocus;
